export default function (obj) {
	return Object.keys(obj).reduce(function(toReturn, k) {

		if (Object.prototype.toString.call(obj[k]) === '[object Date]') {
			toReturn[k] = obj[k].toString();
		}
		else if ((typeof obj[k]) === 'object' && obj[k]) {
			Object.keys(obj[k]).forEach(function(k2) {
				toReturn[k + '.' + k2] = obj[k][k2];
			});
		}
		else {
			toReturn[k] = obj[k];
		}

		return toReturn;
	}, {});
}



/** WEBPACK FOOTER **
 ** ./src/universal/helpers/flattenObject.js
 **/